export const PasswordRegExUrl =
  /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)(\/[\w\-]+)?(\?v=[\w\-]+)?(\/embed\/[\w\-]+)?$/;
export const poorRegExp = /[a-z]/;
export const weakRegExp = /\d/;
export const goodRegExp = /[A-Z#?!@$]/;
export const strongRegExp = /[#?!@$%^&*-]/;
export const whitespaceRegExp = /^\s*$/;
